import React from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import metadata from './EsignatureComponent.metadata.json5';
import messages from './EsignatureComponent.messages';
import appConfig from 'app-config';
import { MLScriptComponent } from 'ml-components-common-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import styles from './EsignatureComponent.module.scss';
import { useEffect, useState } from 'react';

function EsignatureComponent(props) {
    const {
        model: submissionVM,
        viewModelService,
        updateWizardData,
        product
    } = props;

    const translator = useTranslator();
    const statusTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('ESignatureOptions_Ext');
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const [scriptML, updateScriptML] = useState([]);
    const { authHeader } = useAuthentication();

     const formatPhoneNumber = (number) => {
       if (_.isNil(number)) {
         return number;
       }

       const cleanedNumber = String(number).replace(/\D/g, "").slice(0, 10);

       if (cleanedNumber.length !== 10) {
         return number;
       }

       const area = cleanedNumber.substring(0, 3);
       const front = cleanedNumber.substring(3, 6);
       const end = cleanedNumber.substring(6, 10);

       return `${area}-${front}-${end}`;
     };


    useEffect(() => {
        LoadSaveService.getScript(
            "paAdditionalInfoPreBind",
            {
                state: _.get(submissionVM, "baseData.policyAddress.state.value.code")

            },
            authHeader,
        ).then((lines) => {
            updateScriptML(lines);
        });
    }, []);

    const getESignOptions = () => {
        const allowedValues = ["Text", "Email"];
        let codes = statusTypeList.codes.filter((e) => allowedValues.includes(e.code));
        return codes.map((option) => {
            return {
                code: option.code,
                name: translator({
                    id: option.name,
                    defaultMessage: option.name
                })
            };
        });
    };

    const esignOptionValue = _.get(submissionVM, `bindData.esignature_ML.esignatureOptions.value`)?.code
    const mobileValue = formatPhoneNumber(_.get(submissionVM, `bindData.esignature_ML.mobileNumber_Ext.value`)?.code)

    const overrideProps = {
        esignHeading: {
            content: translator(messages.esignHeading)
        },
        esign: {
            label: translator(messages.esign),
            path: `bindData.esignature_ML.esign_Ext`,
            value: _.get(submissionVM, `bindData.esignature_ML.esign_Ext.value`)?.code,
            onValueChange: (value) => {
                const esignMlPath = _.get(submissionVM, `bindData.esignature_ML.value`);
                if (_.isUndefined(esignMlPath)) {
                    _.set(submissionVM, `bindData.esignature_ML`, {});
                }
                _.set(
                    submissionVM,
                    `bindData.esignature_ML.esign_Ext.value`,
                    value
                )
                if(!value){
                     _.set(
                    submissionVM,
                    `bindData.esignature_ML.esignatureOptions.value`,
                     undefined
                )
                }
                updateWizardData(submissionVM);
            }
        },
        esignOptions: {
            label: translator(messages.esignOptions),
            path: `bindData.esignature_ML.esignatureOptions`,
            availableValues: getESignOptions(),
            value: esignOptionValue,
            visible: _.get(submissionVM, `bindData.esignature_ML.esign_Ext.value`, false),
            onValueChange: (value) => {
                const esignMlPath = _.get(submissionVM, `bindData.esignature_ML.value`);
                if (_.isUndefined(esignMlPath)) {
                    _.set(submissionVM, `bindData.esignature_ML`, {});
                }
                _.set(
                    submissionVM,
                    `bindData.esignature_ML.esignatureOptions.value`,
                    value
                )
                updateWizardData(submissionVM);
            }
        },
        esignOptiontMobileNumber: {
            label: translator(messages.esignOptionMobileNumber),
            path: `bindData.esignature_ML.mobileNumber_Ext`,
            visible: _.get(submissionVM, `bindData.esignature_ML.esignatureOptions.value`)?.code === 'Text',
            value: mobileValue,
            onValueChange: (value) => {
                const esignMlPath = _.get(submissionVM, `bindData.esignature_ML.value`);
                if (_.isUndefined(esignMlPath)) {
                    _.set(submissionVM, `bindData.esignature_ML`, {});
                }
                _.set(
                    submissionVM,
                    `bindData.esignature_ML.mobileNumber_Ext.value`,
                    formatPhoneNumber(value)
                )
                updateWizardData(submissionVM);
            }
        },
        mlScriptComponent: {
            visible: isModernProduct && !_.isEmpty(scriptML) && esignOptionValue === "Text",
            mlScript: scriptML,
            isAdditionalInfo:true
        },
        acknowledgementRadioButton: {
            visible: isModernProduct && !_.isEmpty(scriptML) && esignOptionValue === "Text",
            path: `bindData.esignature_ML.esignTextAck_Ext`,
            value: _.get(submissionVM, `bindData.esignature_ML.esignTextAck_Ext.value`),
            onValueChange: (value) => {
                if (!value) {
                    _.set(
                        submissionVM,
                        `bindData.esignature_ML.esignatureOptions.value`,
                        "Email"
                    )
                }
                _.set(
                    submissionVM,
                    `bindData.esignature_ML.esignTextAck_Ext.value`,
                    value
                )
                updateWizardData(submissionVM);
            }
        }
    };

    const resolvers = {
        resolveComponentMap: {
            mlScriptComponent: MLScriptComponent,
        },
        resolveClassNameMap: styles
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            model={submissionVM}
        />
    );
}

export default withViewModelService(EsignatureComponent);
